import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileMainMenuComponent } from './mobile-main-menu.component';
import { MobileMenuItemComponent } from './mobile-menu-item/mobile-menu-item.component';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ConfirmationComponent, IconComponent, TextComponent } from 'ui-kit';
import { MatDialogClose } from '@angular/material/dialog';



@NgModule({
  declarations: [
    MobileMainMenuComponent,
    MobileMenuItemComponent
  ],
  exports: [
    MobileMainMenuComponent
  ],
  imports: [
    CommonModule,
    RouterLinkActive,
    RouterLink,
    IconComponent,
    TextComponent,
    MatDialogClose,
    ConfirmationComponent
  ]
})
export class MobileMainMenuModule { }
